var _serviceEndPoint = null;
var _defaultRefreshRate = 3; //default refresh rate: 3 days

var _msPerDay = 86400000; //24*60*60*1000ms

var _defaultTimeout = 60000; //set timeout to be 60 seconds

var _officeVersionHeader = "X-Office-Version"; //office version HTTP header

var _hourToDayConversionFactor = 24; //hours to days conversion factor

var _buildParameter = "&build=";
var _expectedVersionParameter = "&expver=";
var _queryStringParameters = {
  clientName: "client",
  clientVersion: "cv",
};
var statusCode = {
  Succeeded: 1,
  Failed: 0,
};
var _spUpn = null;
function _sendWebRequest(url, verb, headers, onCompleted, context, body?) {
  context = context || {};
  var webRequest = new Sys.Net.WebRequest();
  for (var p in headers) {
    webRequest.get_headers()[p] = headers[p];
  }
  if (context) {
    if (context.officeVersion) {
      webRequest.get_headers()[_officeVersionHeader] = context.officeVersion;
    }
    if (context.correlationId && url.indexOf("?") > -1) {
      url += "&corr=" + context.correlationId;
    }
  }
  if (body) {
    webRequest.set_body(body);
  }
  webRequest.set_url(url);
  webRequest.set_httpVerb(verb);
  webRequest.set_timeout(_defaultTimeout);
  webRequest.set_userContext(context);
  webRequest.add_completed(onCompleted);
  webRequest.invoke();
}
function _onCompleted(executor, eventArgs) {
  var context = executor.get_webRequest().get_userContext();
  var url = executor.get_webRequest().get_url();
  if (executor.get_timedOut()) {
    //timeout, just invoke callback with status as failed (0)
    OsfMsAjaxFactory.msAjaxDebug.trace("Request timed out: " + url);
    _invokeCallbackTag(context.callback, statusCode.Failed, null, null, executor, 0x1e38c048 /* tag_4ombi */);
  } else if (executor.get_aborted()) {
    //aborted, just invoke callback with status as failed (0)
    OsfMsAjaxFactory.msAjaxDebug.trace("Request aborted: " + url);
    _invokeCallbackTag(context.callback, statusCode.Failed, null, null, executor, 0x1e38c047 /* tag_4ombh */);
  } else if (executor.get_responseAvailable()) {
    if (executor.get_statusCode() == 200) {
      try {
        context._onCompleteHandler(executor, eventArgs);
      } catch (ex) {
        //failed, just invoke callback with status as failed (0)
        OsfMsAjaxFactory.msAjaxDebug.trace("Request failed with exception " + ex + ": " + url);
        _invokeCallbackTag(context.callback, statusCode.Failed, ex, null, executor, 0x1e38c046 /* tag_4ombg */);
      }
    } else {
      //status code is not OK (200), just invoke callback with status as failed (0)
      var statusText = executor.get_statusText();
      OsfMsAjaxFactory.msAjaxDebug.trace("Request failed with status code " + statusText + ": " + url);
      _invokeCallbackTag(context.callback, statusCode.Failed, statusText, null, executor, 0x1e38c045 /* tag_4ombf */);
    }
  } else {
    //failed, just invoke callback with status as failed (0)
    OsfMsAjaxFactory.msAjaxDebug.trace("Request failed: " + url);
    _invokeCallbackTag(context.callback, statusCode.Failed, statusText, null, executor, 0x1e38c044 /* tag_4ombe */);
  }
}
function _isProxyReady(params, callback) {
  if (callback) {
    callback({ status: statusCode.Succeeded, result: true });
  }
}
function _createQueryStringFragment(paramDictionary) {
  var queryString = "";
  for (var param in paramDictionary) {
    var value = paramDictionary[param];
    if (value === null || value === undefined || value === "") {
      continue;
    }
    queryString += "&" + encodeURIComponent(param) + "=" + encodeURIComponent(value);
  }
  return queryString;
}
